/* tslint:disable */
/* eslint-disable */
/**
 * Example API
 * API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateFollowRequest
 */
export interface CreateFollowRequest {
    /**
     * ID of the account to follow
     * @type {string}
     * @memberof CreateFollowRequest
     */
    followingId: string;
}

/**
 * Check if a given object implements the CreateFollowRequest interface.
 */
export function instanceOfCreateFollowRequest(value: object): value is CreateFollowRequest {
    if (!('followingId' in value) || value['followingId'] === undefined) return false;
    return true;
}

export function CreateFollowRequestFromJSON(json: any): CreateFollowRequest {
    return CreateFollowRequestFromJSONTyped(json, false);
}

export function CreateFollowRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateFollowRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'followingId': json['followingId'],
    };
}

  export function CreateFollowRequestToJSON(json: any): CreateFollowRequest {
      return CreateFollowRequestToJSONTyped(json, false);
  }

  export function CreateFollowRequestToJSONTyped(value?: CreateFollowRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'followingId': value['followingId'],
    };
}

